export const SENTIMENT_DATA = {
  today: {
    metrics: [
      { label: 'CSAT', value: '4.8/5', trend: '+0.2', trendUp: true },
      { label: 'NPS', value: '74', trend: '+2', trendUp: true },
      { label: 'Positive', value: '72%', trend: '+4%', trendUp: true },
      { label: 'Negative', value: '9%', trend: '-3%', trendUp: true },
      { label: 'Avg. Response', value: '6 min', trend: '-25%', trendUp: true },
      { label: 'Resolution Sat.', value: '94%', trend: '+3%', trendUp: true },
    ],
    trends: [
      { label: 'CSAT Score', value: '4.8', data: [4.4, 4.5, 4.4, 4.6, 4.5, 4.6, 4.7, 4.6, 4.7, 4.7, 4.8, 4.8], trend: '+0.2', trendUp: true },
      { label: 'NPS', value: '74', data: [68, 70, 69, 71, 70, 72, 71, 72, 73, 72, 74, 74], trend: '+2', trendUp: true },
      { label: 'Ticket Volume', value: '8', data: [2, 3, 2, 4, 3, 5, 4, 6, 5, 7, 6, 8], trend: '+33%', trendUp: false, alert: true },
      { label: 'Resolution Time', value: '3.8 hrs', data: [4.8, 4.5, 4.6, 4.3, 4.4, 4.1, 4.2, 4.0, 4.1, 3.9, 3.9, 3.8], trend: '-15%', trendUp: true },
      { label: 'Positive Mentions', value: '38', data: [18, 22, 20, 25, 23, 28, 26, 30, 32, 34, 35, 38], trend: '+18%', trendUp: true },
      { label: 'Escalation Rate', value: '5%', data: [10, 9, 9, 8, 8, 7, 8, 7, 6, 6, 5, 5], trend: '-3%', trendUp: true },
    ],
    label: 'Today',
  },
  weekly: {
    metrics: [
      { label: 'CSAT', value: '4.6/5', trend: '+0.3', trendUp: true },
      { label: 'NPS', value: '72', trend: '+5', trendUp: true },
      { label: 'Positive', value: '68%', trend: '+4%', trendUp: true },
      { label: 'Negative', value: '12%', trend: '-3%', trendUp: true },
      { label: 'Avg. Response', value: '8 min', trend: '-22%', trendUp: true },
      { label: 'Resolution Sat.', value: '91%', trend: '+2%', trendUp: true },
    ],
    trends: [
      { label: 'CSAT Score', value: '4.6', data: [4.0, 4.1, 4.0, 4.2, 4.1, 4.3, 4.2, 4.3, 4.4, 4.3, 4.5, 4.6], trend: '+0.3', trendUp: true },
      { label: 'NPS', value: '72', data: [56, 58, 60, 59, 62, 64, 63, 66, 68, 69, 71, 72], trend: '+5', trendUp: true },
      { label: 'Ticket Volume', value: '23', data: [12, 14, 15, 13, 16, 15, 18, 17, 19, 20, 22, 23], trend: '+42%', trendUp: false, alert: true },
      { label: 'Resolution Time', value: '4.2 hrs', data: [6.1, 5.8, 5.9, 5.4, 5.2, 5.3, 4.9, 4.8, 4.6, 4.5, 4.3, 4.2], trend: '-18%', trendUp: true },
      { label: 'Positive Mentions', value: '142', data: [88, 95, 98, 102, 108, 105, 112, 118, 124, 130, 136, 142], trend: '+14%', trendUp: true },
      { label: 'Escalation Rate', value: '8%', data: [15, 14, 14, 13, 12, 12, 11, 10, 10, 9, 9, 8], trend: '-4%', trendUp: true },
    ],
    label: 'Last 4 weeks',
  },
  monthly: {
    metrics: [
      { label: 'CSAT', value: '4.4/5', trend: '+0.5', trendUp: true },
      { label: 'NPS', value: '68', trend: '+12', trendUp: true },
      { label: 'Positive', value: '65%', trend: '+8%', trendUp: true },
      { label: 'Negative', value: '14%', trend: '-6%', trendUp: true },
      { label: 'Avg. Response', value: '12 min', trend: '-35%', trendUp: true },
      { label: 'Resolution Sat.', value: '88%', trend: '+5%', trendUp: true },
    ],
    trends: [
      { label: 'CSAT Score', value: '4.4', data: [3.6, 3.8, 3.7, 3.9, 4.0, 3.9, 4.0, 4.1, 4.2, 4.1, 4.3, 4.4], trend: '+0.5', trendUp: true },
      { label: 'NPS', value: '68', data: [44, 48, 46, 50, 52, 54, 56, 58, 62, 64, 66, 68], trend: '+12', trendUp: true },
      { label: 'Ticket Volume', value: '86', data: [55, 60, 62, 58, 64, 68, 66, 72, 74, 78, 82, 86], trend: '+38%', trendUp: false, alert: true },
      { label: 'Resolution Time', value: '5.1 hrs', data: [7.8, 7.2, 7.4, 6.8, 6.4, 6.5, 6.0, 5.8, 5.6, 5.4, 5.2, 5.1], trend: '-28%', trendUp: true },
      { label: 'Positive Mentions', value: '520', data: [300, 330, 340, 360, 380, 390, 410, 420, 450, 470, 495, 520], trend: '+22%', trendUp: true },
      { label: 'Escalation Rate', value: '10%', data: [19, 18, 18, 16, 15, 15, 14, 13, 12, 11, 11, 10], trend: '-8%', trendUp: true },
    ],
    label: 'Last 3 months',
  },

  feedback: [
    { id: 'f1', customer: 'Acme Corp', rating: 2, sentiment: 'negative', excerpt: 'API downtime cost us 3 hours of productivity. Unacceptable for an enterprise product.', source: 'Ticket', date: 'Today' },
    { id: 'f2', customer: 'CloudNine', rating: 4, sentiment: 'positive', excerpt: 'The auto-response for webhook config was really helpful. Solved my issue in 5 minutes.', source: 'Survey', date: 'Today' },
    { id: 'f3', customer: 'NovaTech', rating: 3, sentiment: 'neutral', excerpt: 'SSO setup took longer than expected but support was responsive.', source: 'Survey', date: 'Yesterday' },
    { id: 'f4', customer: 'AgriTech Co', rating: 5, sentiment: 'positive', excerpt: 'Incredible support. Fixed my report template issue within 30 minutes.', source: 'Ticket', date: 'Yesterday' },
    { id: 'f5', customer: 'Pinnacle Systems', rating: 5, sentiment: 'positive', excerpt: 'iOS crash was fixed same day. Really impressed with the turnaround.', source: 'Chat', date: 'Yesterday' },
    { id: 'f6', customer: 'Meridian Group', rating: 1, sentiment: 'negative', excerpt: 'Onboarding is broken. I\'ve been stuck for a week and nobody is helping.', source: 'Ticket', date: '2 days ago' },
    { id: 'f7', customer: 'DataFlow', rating: 3, sentiment: 'neutral', excerpt: 'Export timeouts are frustrating but I understand it\'s being worked on.', source: 'Survey', date: '2 days ago' },
    { id: 'f8', customer: 'Vertex Labs', rating: 2, sentiment: 'negative', excerpt: 'Dashboard is painfully slow with our team size. Need this fixed ASAP.', source: 'Chat', date: '3 days ago' },
  ],

  brandReputation: {
    google: { rating: 4.3, reviews: 128, trend: '+0.2', recent: [
      { author: 'Sarah M.', rating: 5, text: 'Great product, excellent customer support team.', date: '2 days ago' },
      { author: 'Mike R.', rating: 3, text: 'Solid tool but the recent updates broke some workflows.', date: '4 days ago' },
      { author: 'Priya K.', rating: 5, text: 'Onboarding was smooth. The AI features are genuinely useful.', date: '1 week ago' },
    ]},
    g2: { rating: 4.5, reviews: 89, trend: '+0.1', badges: ['High Performer', 'Easiest Setup', 'Best Support'] },
    capterra: { rating: 4.4, reviews: 64, trend: '0', badges: ['Shortlist 2025'] },
    socialListening: {
      mentions: 342,
      mentionsTrend: '+18%',
      positive: 68,
      negative: 12,
      neutral: 20,
      topTopics: [
        { topic: 'Customer support speed', sentiment: 'positive', count: 48 },
        { topic: 'v3.2 webhook issues', sentiment: 'negative', count: 31 },
        { topic: 'AI agent features', sentiment: 'positive', count: 62 },
        { topic: 'Pricing value', sentiment: 'neutral', count: 24 },
        { topic: 'Mobile app quality', sentiment: 'positive', count: 19 },
      ],
      platforms: [
        { name: 'Twitter/X', mentions: 142, sentiment: 72 },
        { name: 'LinkedIn', mentions: 98, sentiment: 81 },
        { name: 'Reddit', mentions: 58, sentiment: 54 },
        { name: 'Product Hunt', mentions: 44, sentiment: 88 },
      ],
    },
  },

  insights: [
    { id: 'si1', text: 'Negative sentiment is concentrated around v3.2 changes — webhook configs and performance regressions account for 65% of negative feedback.', type: 'alert', time: '2 hrs ago' },
    { id: 'si2', text: 'CSAT improved 0.3 points this week driven by faster first response times (8 min avg, down from 10 min). Auto-responses are contributing.', type: 'insight', time: '4 hrs ago' },
    { id: 'si3', text: 'Meridian Group\'s feedback is deteriorating rapidly (rating 1). This correlates with their churn risk score. Recommend immediate executive intervention.', type: 'recommendation', time: '5 hrs ago' },
    { id: 'si4', text: 'Positive mentions up 14% — customers are highlighting fast resolution and proactive communication. This is a competitive differentiator.', type: 'insight', time: 'Yesterday' },
  ],
};

export const SENTIMENT_CHAT_RESPONSES = {
  general: {
    text: "Here's your sentiment analysis.\n\nOverall sentiment is trending positive — CSAT at 4.6/5 (up 0.3), NPS at 72 (up 5), and 68% of feedback is positive. Resolution satisfaction hit 91%.\n\nThe negative sentiment (12%) is concentrated around two themes: v3.2 webhook changes and performance regressions. Two accounts (Meridian, Vertex Labs) are driving most of the negative feedback.\n\nNotably, the auto-response system is generating positive reactions — CloudNine specifically praised the webhook config guide. Want me to analyze any specific sentiment trend?",
  },
};
